import React, { useEffect, useMemo, useState } from "react";
import SearchHeader from "../Reuseablecomponent/SearchHeader";
import UserMasterModal from "./Modals/UserMasterModal";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import "./Users.scss";
import {
  userAction,
  userTableDataStart,
} from "../../redux/actions/MasterActions";
import { privateRequest } from "../../api/apiConfig/privateRequest";
import DeleteModal from "./Modals/DeleteModal";
import Pagination from "../Reuseablecomponent/Pagination";
import { DateFilterIcon, DeleteIcon, EditIcon } from "../../Icon";
import Loader from "../loader/Loader";
import {
  showErrorNotification,
  showSuccessNotification,
  statusToggleFunc,
} from "../../customHooks";
import { Link } from "react-router-dom";
import Switch from "react-switch";
import { USERS_TABLE_DATA_START } from "../../redux/actionsTypes/Types";
import { dateConvertTo_YYYY_MM_DD } from "../../utils/CommonFunction";
import DateFilter from "./Modals/DateFilter";
import { slice } from "lodash";
import { Tooltip } from "react-bootstrap";
import { DATA_NOT_FOUND } from "../../constant";

const Users = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isDateOpen, setDateOpen] = useState(false);
  const [dateData, setdateData] = useState([]);
  const [data, setData] = useState([]);
  const { users, isDataFetch, pageCount, message } = useSelector(
    (state) => state.master["users"]
  );
  const dispatch = useDispatch();
  const [isdeletemodal, setIsdeletemodal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [isdateFilter, setDateFilter] = useState(false);
  const [reload, setReload] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [pageNo, setPageNo] = useState(1);
  const [iscondition, setIscondition] = useState(false);
  const [getDate, setGetDate] = useState();
  const getSearchValue = (value) => {
    setSearchValue(value);
  };
  const openModal = (e, value) => {
    setIsOpen(true);
    setData(value);
  };
  const closeModal = () => {
    setIsOpen(false);
  };

  const openDateFilter = (e, value) => {
    setDateOpen(true);
    // dateData(value)
  };
  const closeDateFilter = () => {
    setDateOpen(false);
  };

  const openDeleteModal = (id) => {
    setIsdeletemodal(true);
    setDeleteId(id);
  };
  const closeDeleteModal = () => {
    setIsdeletemodal(false);
    setDeleteId(null);
  };
  const updateData = async (values) => {
    try {
      await privateRequest.put(`/user/${values.id}`, values);
      showSuccessNotification("Resource Updated Successfully ");
      setReload((prevState) => {
        return !prevState;
      });
    } catch (error) {}
  };

  const addData = async (values) => {
    try {
      const temp = {
        ...values,
        dob: values.dob ? dateConvertTo_YYYY_MM_DD(values.dob) : "",
        careerStartDate: values.careerStartDate
          ? dateConvertTo_YYYY_MM_DD(values.careerStartDate)
          : "",
        dateOfJoining: values.dateOfJoining
          ? dateConvertTo_YYYY_MM_DD(values.dateOfJoining)
          : "",
      };
      await privateRequest.post("/user", temp);
      showSuccessNotification("Added Successfully!");
      setReload((prevState) => {
        return !prevState;
      });
    } catch (error) {}
  };

  const deletePropsConfig = {
    closeDeleteModal,
    isdeletemodal,
    url: "user",
    deleteId: deleteId,
    setReload,
  };
  const crudConfig = {
    title: "Resources",
    isOpen,
    closeModal,
    data,
    updateData,
    addData,
  };
  const dateConfig = {
    setGetDate,
    isDateOpen,
    dateData,
    closeDateFilter,
    setIscondition,
  };

  const clearDateFilter = () => {
    setIscondition(false);
  };

  const handleActiveUser = async (value, id) => {
    statusToggleFunc("user", id, setReload, value);
  };
  const paginationProps = {
    setPageNo,
    pageSize,
    setPageSize,
    pageCount,
  };
  useEffect(() => {
    let payload = {};

    if (iscondition) {
      dispatch(
        userAction(
          USERS_TABLE_DATA_START,
          (payload = { condition: false, from: getDate.from, to: getDate.to })
        )
      );
    } else {
      dispatch(
        userAction(
          USERS_TABLE_DATA_START,
          (payload = { searchValue, pageNo, pageSize, condition: true })
        )
      );
    }
  }, [searchValue, pageNo, pageSize, reload, iscondition]);
  return (
    <div>
      <SearchHeader
        title="Resources"
        openModal={openModal}
        getSearchValue={getSearchValue}
        setPageNo={setPageNo}
        searchDate={true}
      />
      {isOpen && <UserMasterModal {...crudConfig} />}
      {isdeletemodal && <DeleteModal {...deletePropsConfig} />}
      {isDateOpen && <DateFilter {...dateConfig} />}
      <div className="usertab">
        <div className="users">
          <table className="users__table">
            <thead className="users__table--thead">
              <tr style={{ cursor: "context-menu" }}>
                <th>Full Name</th>
                <th>Email ID</th>
                <th>Language</th>
                <th>Vendors</th>
                <th>Summary</th>
                <th>Designation</th>
                <th>Experience</th>
                {/* <th>Gender</th> */}
                <th style={{ cursor: "pointer" }}>
                  <abbr
                    style={{ textDecoration: "none", cursor: "context-menu" }}
                    title="Date of Joining"
                  >
                    DOJ
                  </abbr>
                  <DateFilterIcon openModal={openDateFilter} data={dateData} />
                  {iscondition && (
                    <button onClick={clearDateFilter}>Clear</button>
                  )}
                </th>
                <th>Projects</th>
                <th>Laptop Config</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody className="users__table--tbody">
              {isDataFetch ? (
                <tr>
                  <td colSpan={9}>
                    <Loader />
                  </td>
                </tr>
              ) : users.length === 0 ? (
                <tr>
                  <td colSpan={6} style={{ textAlign: "end", color: "red" }}>
                    {DATA_NOT_FOUND}
                  </td>
                </tr>
              ) : (
                // <div style={{ textAlign: "center" }}>No </div>
                users.map((data) => (
                  <tr key={data.id}>
                    <td>
                      {data.name || (
                        <div style={{ textAlign: "center", width: "50%" }}>
                          --
                        </div>
                      )}
                    </td>
                    <td
                      data-toggle="tooltip"
                      data-placement="top"
                      title={data.email}
                    >
                      {data.email &&
                        data.email?.slice(0, 10).toLowerCase() + "..."}
                    </td>
                    <td
                      data-toggle="tooltip"
                      data-placement="top"
                      title={data.technicalStack}
                    >
                      {(data.technicalStack &&
                        data.technicalStack?.slice(0, 10) + "...") || (
                        <div style={{ textAlign: "center", width: "50%" }}>
                          --
                        </div>
                      )}{" "}
                    </td>
                    <td
                      data-toggle="tooltip"
                      data-placement="top"
                      title={data.vendor}
                    >
                      {(data.vendor && data.vendor?.slice(0, 10) + "...") || (
                        <div style={{ textAlign: "center", width: "50%" }}>
                          --
                        </div>
                      )}
                    </td>
                    <td
                      data-toggle="tooltip"
                      data-placement="top"
                      title={data.summary}
                    >
                      {(data.summary && data.summary?.slice(0, 10) + "...") || (
                        <div style={{ textAlign: "center", width: "50%" }}>
                          --
                        </div>
                      )}
                    </td>
                    <td>
                      {data.designationName || (
                        <div style={{ textAlign: "center", width: "50%" }}>
                          --
                        </div>
                      )}
                    </td>
                    <td>
                      {data.experience || (
                        <div style={{ textAlign: "center", width: "50%" }}>
                          --
                        </div>
                      )}
                    </td>

                    <td>
                      {(data.dateOfJoining &&
                        new Date(moment(data.dateOfJoining)).toLocaleDateString(
                          "en-US",
                          { year: "numeric", month: "short", day: "numeric" }
                        )) || (
                        <div style={{ textAlign: "center", width: "50%" }}>
                          --
                        </div>
                      )}
                    </td>
                    <td style={{ color: "blue" }}>
                      {" "}
                      <Link
                        style={{ textDecoration: "none" }}
                        to={`/project/admin/${data.id}`}
                      >
                        View
                      </Link>
                    </td>
                    <td
                      data-toggle="tooltip"
                      data-placement="top"
                      title={data.laptopConfiguration}
                    >
                      {(data.laptopConfiguration &&
                        data.laptopConfiguration?.slice(0, 10) + "...") || (
                        <div style={{ textAlign: "center", width: "50%" }}>
                          --
                        </div>
                      )}
                    </td>
                    <td>
                      <Switch
                        size="xs"
                        onChange={(e) => handleActiveUser(e, data.id)}
                        checked={data.isActive}
                        onstyle="info"
                        onColor="#86d3ff"
                        onHandleColor="#2693e6"
                        handleDiameter={18}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 0px 2px rgba(0, 0, 0, 0.5)"
                        activeBoxShadow="0px 0px 0px 1px rgba(0, 0, 0, 0.2)"
                        height={15}
                        width={35}
                        id="material-switch"
                        className="react-switch"
                      />
                    </td>
                    <td>
                      <EditIcon openModal={openModal} data={data} />
                      <DeleteIcon
                        openDeleteModal={openDeleteModal}
                        data={data}
                        enabled={true}
                      />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Pagination {...paginationProps} />{" "}
    </div>
  );
};

export default Users;
